import * as R from 'ramda'
import tap from 'tap-logger'
import StickerMessagePreview from '../components/sticker-message-preview.vue'
window.R = R

const processStamps = labels => R.pipe(
	R.chain(label =>
		R.map(stamp =>
				({
				font: R.pathOr({}, ['font'], label),
				container: R.pathOr({}, ['template', 'container'], label),
				stamp
				}),
			label.template.stamps
		)
	)
)(labels)


export const cart = {
	el: '#cart-vue',
	mixins: [],
	components: {
		StickerMessagePreview
	},

	ready() {
		this.processedProducts = this.processProducts(this.items)
	},

	watch: {
		cart() {
			this.processedProducts = this.processProducts(this.items)
		},

		previewData() {
			this.fonts = R.pipe(
				R.pathOr([], ['stamps']),
				R.map(R.path(['font', 'google_url'])),
				R.reject(R.isNil),
				R.concat(this.fonts),
				R.uniq,
			)(this.previewData)

			this.$broadcast('resize-font')
		},
	},

	data: {
		processedProducts: [],//no la hacemos computada porque necesitamos tener la refencia al objeto cuando hacemos los updates de cantidad, y las propiedades computadas no nos permite hacer esto fácilmente
		previewCache: {},//{item_id: StickerPreview}
		previewedSticker: {},
		fonts: [],
	},

	computed: {
		products() {
			return R.pathOr([], ['store', 'cart', 'data'], this)
		},


		hasProducts() {
			return this.processedProducts.length > 0
		},

		cart() {
			return R.pathOr({}, ['store', 'cart', 'data'], this)
		},

		items() {
			return R.pathOr([], ['cart', 'items'], this)
		},

		subtotal() {
			return R.pathOr('$0', ['cart', 'formated_subtotal'], this)
		},

		total() {
			return R.pathOr('$0', ['cart', 'formated_total'], this)
		},

		previewData() {
			return R.pipe(
				R.pick(['customizations', 'labels']),
				({customizations, labels}) => ({
					texts: R.pathOr([], ['texts'], customizations),
					stamps: processStamps(labels || {}),
				}),
			)(this.previewedSticker)
		},

	},

	methods: {
		isEmpty: R.isEmpty,

		processProducts(items) {
			return R.pipe(
				R.map(
					({
						item_id,
						description,
						name,
						formated_buyable_price,
						formated_total_buyable_price,
						customizations,
						quantity,
						thumbnail_url,
						computed_description
					}) =>
					({
						item_id,
						description,
						name,
						price: formated_buyable_price,
						total_price: formated_total_buyable_price,
						texts: R.pathOr([], ['texts'], customizations),
						quantity,
						new_quantity: quantity,
						img: thumbnail_url,
						computed_description
					})
				)
			)(items)
		},

		quantityHasChanged(product) {
			return product.quantity !== Number(product.new_quantity)
		},

		updateQuantity(product) {
			let url = R.pipe(
				R.replace('__id__', product.item_id),
			)(this.$root.store.routes.updateQuantity.post)

			this.$http.post(url, {
				_method: 'PATCH',
				_token: this.$root.store.csrf_token,
				quantity: product.new_quantity
			})
				//TODO
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.alert(body)
					this.store.cart.data = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		removeFromCart(item_id) {
			let url = R.pipe(
				R.replace('__id__', item_id),
			)(this.$root.store.routes.removeFromCart.post)

			this.$http.post(url, {
				_method: 'DELETE',
				_token: this.$root.store.csrf_token
			})
				//TODO
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.$root.store.cart.data = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		getStickerPreview(item_id) {
			let url = R.pipe(
				R.replace('__item_id__', item_id),
			)(this.$root.store.routes.stickerPreview.get)

			if(this.previewCache[item_id]) {//para no hacer un get cada vez que se vea el mismo sticker
				this.previewedSticker = this.previewCache[item_id]
				return
			}

			this.$http.get(url)
				//TODO
				.then(tap.c('getStickerPreview'))
				.then(R.path(['body']))
				.then(data => {
					this.previewCache[item_id] = data
					this.previewedSticker = this.previewCache[item_id]
					return data
				})
				.catch(err => {
					this.alertError(['intergar notificacion de error de getStickerPreview'])
					this.previewedSticker = {something: 'blaaa'}
				})
		},

		closeStickerPreview() {
			this.previewedSticker = {}
		}
	}
};
